import React from "react";

const ContactUs = () => {
    return (
        <div className="App flex justify-center items-center">
			<div className="glass1 p-5 w-full max-w-xl">
				<h1 className="mb-2 text-md sm:text-xl md:text-2xl lg:text-2xl xl:text-2xl font-medium font-bold leading-none tracking-tight text-gray-900 dark:text-white text-center">
					Have Any Questions?
				</h1>
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-center">
                    Need support, have questions about our Terms and Conditions, or have a general inquiry?<br/>Contact us using one of the buttons below!
                </label>

                <div className="contactBtnContainer mt-2 w-100">
                    <button type="button" className="contactButton" id="email-btn" onClick={() => window.open('mailto:support@scansolutions.com')}>
                        Send us an email
                    </button>
                </div>
                <div className="contactBtnContainer mt-2 w-100">
                    <button type="button" className="contactButton" id="academy-btn" onClick={() => window.open('https://academy.scansolutions.com/')}>
                        Visit Scan Solutions Academy
                    </button>
                </div>
                <div className="flex justify-between items-center mt-10">
                    <label className="block inline-flex text-sm font-medium text-gray-900 dark:text-white text-center">
                        9700 Farrar Ct<br/>
                        North Chesterfield,<br/>
                        Virginia 23236
                    </label>
                    <label className="block inline-flex text-sm font-medium text-gray-900 dark:text-white text-center">
                        <a href="tel:+1 (866) 834-1194">+1 (866) 834-1194</a>
                    </label>
                    <label className="block inline-flex text-sm font-medium text-gray-900 dark:text-white text-center">
                        <a href="https://scansolutions.com" target="_blank" rel="noopener noreferrer">scansolutions.com</a>
                    </label>
                </div>
			</div>
		</div>
    )
}

export default ContactUs